"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerMessageElement = exports.MobilitySummaryElement = exports.CustomerSummaryElement = exports.SimpleVehicleSummaryElement = exports.VehicleSummaryElement = exports.TimeslotSummaryElement = exports.ServiceSummaryElement = exports.GarageSummaryElement = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/de");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _currency = require("../../currency");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GarageSummaryElement = function (_React$Component) {
  _inherits(GarageSummaryElement, _React$Component);

  function GarageSummaryElement(props) {
    _classCallCheck(this, GarageSummaryElement);

    return _possibleConstructorReturn(this, (GarageSummaryElement.__proto__ || Object.getPrototypeOf(GarageSummaryElement)).call(this, props));
  }

  _createClass(GarageSummaryElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Ihr Standort")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement("strong", null, this.props.garage.Name), _react2.default.createElement("br", null), _react2.default.createElement("small", null, this.props.garage.Address, ", ", this.props.garage.ZipCode, " ", this.props.garage.City)))));
    }
  }]);

  return GarageSummaryElement;
}(_react2.default.Component);

GarageSummaryElement.defaultProps = {
  garage: {
    Name: "",
    Address: "",
    ZipCode: "",
    City: ""
  }
};
GarageSummaryElement.propTypes = {
  garage: _propTypes2.default.object
};

var MobilitySummaryElement = function (_React$Component2) {
  _inherits(MobilitySummaryElement, _React$Component2);

  function MobilitySummaryElement(props) {
    _classCallCheck(this, MobilitySummaryElement);

    return _possibleConstructorReturn(this, (MobilitySummaryElement.__proto__ || Object.getPrototypeOf(MobilitySummaryElement)).call(this, props));
  }

  _createClass(MobilitySummaryElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Ihre Ersatzmobilit\xE4t")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement("strong", null, this.props.mobility.Name)))));
    }
  }]);

  return MobilitySummaryElement;
}(_react2.default.Component);

MobilitySummaryElement.defaultProps = {
  mobility: {
    Name: ""
  }
};
MobilitySummaryElement.propTypes = {
  mobility: _propTypes2.default.object
};

var ServiceSummaryElement = function (_React$Component3) {
  _inherits(ServiceSummaryElement, _React$Component3);

  function ServiceSummaryElement(props) {
    _classCallCheck(this, ServiceSummaryElement);

    return _possibleConstructorReturn(this, (ServiceSummaryElement.__proto__ || Object.getPrototypeOf(ServiceSummaryElement)).call(this, props));
  }

  _createClass(ServiceSummaryElement, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var hasZeroPriceHit = false;
      var priceSum = 0;
      this.props.services.forEach(function (service) {
        priceSum += service.Price;
        if (service.Price === 0) hasZeroPriceHit = true;
      });
      var totalPriceLabel = this.props.formData.initialData.hidePrices ? "" : "Preis gesamt: ";
      var totalPrice = this.props.formData.initialData.hidePrices ? "" : hasZeroPriceHit ? "auf Anfrage" : (0, _currency.currencyConverter)(priceSum);
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2"
      }, "Ihre Services")), this.props.services.map(function (item, index) {
        return _react2.default.createElement("tr", {
          key: index
        }, _react2.default.createElement("td", null, item.Name, _this4.props.formData.initialData.hidePrices ? "" : ": "), _react2.default.createElement("td", {
          className: "right nowrap"
        }, _this4.props.formData.initialData.hidePrices ? "" : item.Price > 0 ? (0, _currency.currencyConverter)(item.Price) : "auf Anfrage"));
      }), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2",
        className: "right nowrap"
      }, totalPriceLabel, _react2.default.createElement("strong", null, totalPrice)))));
    }
  }]);

  return ServiceSummaryElement;
}(_react2.default.Component);

ServiceSummaryElement.propTypes = {
  services: _propTypes2.default.array.isRequired
};

var TimeslotSummaryElement = function (_React$Component4) {
  _inherits(TimeslotSummaryElement, _React$Component4);

  function TimeslotSummaryElement(props) {
    _classCallCheck(this, TimeslotSummaryElement);

    return _possibleConstructorReturn(this, (TimeslotSummaryElement.__proto__ || Object.getPrototypeOf(TimeslotSummaryElement)).call(this, props));
  }

  _createClass(TimeslotSummaryElement, [{
    key: "render",
    value: function render() {
      var m = (0, _moment2.default)(this.props.day);
      m.locale("de");
      m.hour(this.props.hour);
      m.minute(this.props.minute);
      var timeLabel = m.format("dddd, DD.MM.YYYY, HH:mm");
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", null, "Ihr Termin")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, _react2.default.createElement("strong", null, this.props.day ? timeLabel : null)))));
    }
  }]);

  return TimeslotSummaryElement;
}(_react2.default.Component);

var VehicleSummaryElement = function (_React$Component5) {
  _inherits(VehicleSummaryElement, _React$Component5);

  function VehicleSummaryElement(props) {
    _classCallCheck(this, VehicleSummaryElement);

    return _possibleConstructorReturn(this, (VehicleSummaryElement.__proto__ || Object.getPrototypeOf(VehicleSummaryElement)).call(this, props));
  }

  _createClass(VehicleSummaryElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2"
      }, "Ihre Fahrzeugdaten")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Marke:"), _react2.default.createElement("td", null, this.props.brand)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Model:"), _react2.default.createElement("td", null, this.props.model)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Typ:"), _react2.default.createElement("td", null, this.props.type)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "km-Stand:"), _react2.default.createElement("td", null, this.props.mileage)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Erstzulassung:"), _react2.default.createElement("td", null, this.props.registerDate)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Kennzeichen:"), _react2.default.createElement("td", null, this.props.licensePlate)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Fin:"), _react2.default.createElement("td", null, this.props.fin))));
    }
  }]);

  return VehicleSummaryElement;
}(_react2.default.Component);

VehicleSummaryElement.propTypes = {
  brand: _propTypes2.default.string.isRequired,
  model: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  mileage: _propTypes2.default.string.isRequired,
  registerDate: _propTypes2.default.string.isRequired,
  licensePlate: _propTypes2.default.string.isRequired,
  fin: _propTypes2.default.string.isRequired
};

var SimpleVehicleSummaryElement = function (_React$Component6) {
  _inherits(SimpleVehicleSummaryElement, _React$Component6);

  function SimpleVehicleSummaryElement(props) {
    _classCallCheck(this, SimpleVehicleSummaryElement);

    return _possibleConstructorReturn(this, (SimpleVehicleSummaryElement.__proto__ || Object.getPrototypeOf(SimpleVehicleSummaryElement)).call(this, props));
  }

  _createClass(SimpleVehicleSummaryElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2"
      }, "Ihre Fahrzeugdaten")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Kennzeichen:"), _react2.default.createElement("td", null, this.props.licensePlate)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Fin:"), _react2.default.createElement("td", null, this.props.fin)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "km-Stand:"), _react2.default.createElement("td", null, this.props.mileage))));
    }
  }]);

  return SimpleVehicleSummaryElement;
}(_react2.default.Component);

SimpleVehicleSummaryElement.propTypes = {
  mileage: _propTypes2.default.string.isRequired,
  licensePlate: _propTypes2.default.string.isRequired,
  fin: _propTypes2.default.string.isRequired
};

var CustomerSummaryElement = function (_React$Component7) {
  _inherits(CustomerSummaryElement, _React$Component7);

  function CustomerSummaryElement(props) {
    _classCallCheck(this, CustomerSummaryElement);

    return _possibleConstructorReturn(this, (CustomerSummaryElement.__proto__ || Object.getPrototypeOf(CustomerSummaryElement)).call(this, props));
  }

  _createClass(CustomerSummaryElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2"
      }, "Ihre Daten")), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Name:"), _react2.default.createElement("td", null, this.props.firstName, " ", this.props.lastName)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Firmenname:"), _react2.default.createElement("td", null, this.props.company)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "E-Mail:"), _react2.default.createElement("td", null, this.props.email)), _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        className: "org"
      }, "Telefon:"), _react2.default.createElement("td", null, this.props.phone))));
    }
  }]);

  return CustomerSummaryElement;
}(_react2.default.Component);

CustomerSummaryElement.propTypes = {
  firstName: _propTypes2.default.string.isRequired,
  lastName: _propTypes2.default.string.isRequired,
  company: _propTypes2.default.string.isRequired,
  email: _propTypes2.default.string.isRequired,
  phone: _propTypes2.default.string.isRequired
};

var CustomerMessageElement = function (_React$Component8) {
  _inherits(CustomerMessageElement, _React$Component8);

  function CustomerMessageElement(props) {
    _classCallCheck(this, CustomerMessageElement);

    return _possibleConstructorReturn(this, (CustomerMessageElement.__proto__ || Object.getPrototypeOf(CustomerMessageElement)).call(this, props));
  }

  _createClass(CustomerMessageElement, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("table", null, _react2.default.createElement("tbody", null, _react2.default.createElement("tr", null, _react2.default.createElement("td", {
        colSpan: "2"
      }, "Ihre Nachricht")), _react2.default.createElement("tr", null, _react2.default.createElement("td", null, this.props.message))));
    }
  }]);

  return CustomerMessageElement;
}(_react2.default.Component);

CustomerMessageElement.propTypes = {
  message: _propTypes2.default.string
};
exports.GarageSummaryElement = GarageSummaryElement;
exports.ServiceSummaryElement = ServiceSummaryElement;
exports.TimeslotSummaryElement = TimeslotSummaryElement;
exports.VehicleSummaryElement = VehicleSummaryElement;
exports.SimpleVehicleSummaryElement = SimpleVehicleSummaryElement;
exports.CustomerSummaryElement = CustomerSummaryElement;
exports.MobilitySummaryElement = MobilitySummaryElement;
exports.CustomerMessageElement = CustomerMessageElement;